import { FC, PropsWithChildren } from "react";

const NotificationProvider: FC<PropsWithChildren> = ({ children }) => {
  return <>{children}</>;
};

export default NotificationProvider;
